<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 196 132" style="enable-background:new 0 0 196 132;" xml:space="preserve">
<path id="Path_250" style="fill:#F9F7F8;" d="M190.3,132H5.7c-3.2,0-5.7-2.6-5.7-5.7l0,0V5.7C0,2.6,2.6,0,5.7,0h184.6
	c3.2,0,5.7,2.6,5.7,5.7v120.5C196,129.4,193.4,132,190.3,132C190.3,132,190.3,132,190.3,132z"/>
<path id="Path_251" style="fill:#EFEDEF;" d="M196,5.7v120.5c0,3.2-2.6,5.7-5.7,5.7c0,0,0,0,0,0h-7.9c3.2,0,5.7-2.6,5.7-5.7V5.7
	c0-3.2-2.6-5.7-5.7-5.7h7.9C193.4,0,196,2.6,196,5.7C196,5.7,196,5.7,196,5.7z"/>
<g id="Group_534" transform="translate(-6.633 52.403)">
	<path id="Rectangle_473" style="fill:#D7D0D6;" d="M23.6,38.6h161.8c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2H23.6c-1.1,0-2-0.9-2-2v-24
		C21.6,39.5,22.5,38.6,23.6,38.6z"/>
	<path id="Rectangle_474" style="fill:#E5E1E5;" d="M17.6,38.6h161.8c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2H17.6c-1.1,0-2-0.9-2-2v-24
		C15.6,39.5,16.5,38.6,17.6,38.6z"/>
</g>
<path id="Path_256" style="fill:#0084C8;" d="M196,5.7v17.1H0V5.7C0,2.6,2.6,0,5.7,0h184.5C193.4,0,196,2.6,196,5.7L196,5.7z"/>
<path id="Path_257" style="fill:#0075B1;" d="M196,5.7v17.1h-7.9V5.7c0-3.2-2.6-5.7-5.7-5.7h8C193.4,0,196,2.6,196,5.7z"/>
<g id="Group_528" transform="translate(-0.176 3)">
	<g id="Group_519" transform="translate(9.615 38)">
		<path id="Path_260" style="fill:#E5E1E5;" d="M42.6,5.8H2.9C1.3,5.7,0,4.4,0,2.8C0.1,1.3,1.3,0,2.9,0h39.7c1.6,0,2.9,1.2,2.9,2.8
			c0,1.6-1.2,2.9-2.8,2.9C42.6,5.8,42.6,5.8,42.6,5.8z"/>
	</g>
	<g id="Group_523" transform="translate(9.615 53)">
		<path id="Path_260-2" style="fill:#E5E1E5;" d="M42.6,5.8H2.9C1.3,5.7,0,4.4,0,2.8C0.1,1.3,1.3,0,2.9,0h39.7
			c1.6,0,2.9,1.2,2.9,2.8c0,1.6-1.2,2.9-2.8,2.9C42.6,5.8,42.6,5.8,42.6,5.8z"/>
	</g>
	<g id="Group_524" transform="translate(9.615 67)">
		<path id="Path_260-3" style="fill:#E5E1E5;" d="M42.6,5.8H2.9C1.3,5.7,0,4.4,0,2.8C0.1,1.3,1.3,0,2.9,0h39.7
			c1.6,0,2.9,1.2,2.9,2.8c0,1.6-1.2,2.9-2.8,2.9C42.6,5.8,42.6,5.8,42.6,5.8z"/>
	</g>
</g>
<g id="Group_532" transform="translate(-1.176 3)">
	<g id="Group_529" transform="translate(72.439 38)">
		<path id="Path_260-4" style="fill:#E5E1E5;" d="M42.5,5.8H2.8C1.2,5.7-0.1,4.4,0,2.8C0,1.3,1.2,0,2.8,0h39.7
			c1.6,0,2.9,1.2,2.9,2.8c0,1.6-1.2,2.9-2.8,2.9C42.5,5.8,42.5,5.8,42.5,5.8z"/>
	</g>
	<g id="Group_526" transform="translate(72.439 53)">
		<path id="Path_260-5" style="fill:#E5E1E5;" d="M42.5,5.8H2.8C1.2,5.7-0.1,4.4,0,2.8C0,1.3,1.2,0,2.8,0h39.7
			c1.6,0,2.9,1.2,2.9,2.8c0,1.6-1.2,2.9-2.8,2.9C42.5,5.8,42.5,5.8,42.5,5.8z"/>
	</g>
	<g id="Group_531" transform="translate(72.439 67)">
		<path id="Path_260-6" style="fill:#E5E1E5;" d="M42.5,5.8H2.8C1.2,5.7-0.1,4.4,0,2.8C0,1.3,1.2,0,2.8,0h39.7
			c1.6,0,2.9,1.2,2.9,2.8c0,1.6-1.2,2.9-2.8,2.9C42.5,5.8,42.5,5.8,42.5,5.8z"/>
	</g>
</g>
</svg>
